// Client module - handles all client-related functionality
import {
    buscarEnderecoPorCep,
    buscarDadosCnpj,
    setupInfiniteScroll,
    setupSearch,
} from "../../utils/common.js";
import "select2";
import { initClientFilters } from "./filter.js";
import "./selection.js";

// Client listing with infinite scroll
if ($("body").hasClass("client-index")) {
    initClientFilters();
    const infiniteScrollInstance = setupInfiniteScroll(
        ".tbodyClients",
        "/clientes"
    );

    $(document).on("listing:reset", function () {
        if (infiniteScrollInstance) {
            infiniteScrollInstance.reset();
        }
    });
}

// Função loadMoreClients removida - agora usando setupInfiniteScroll

// Client search functionality
setupSearch(
    "#searchClient",
    "/clientes/search",
    ".table-client",
    ".tbodyClients",
    function () {
        return {
            tipo_cliente: $("#tipoCliente").val(),
            uf: $("#ufFilter").val(),
            cidade: $("#cidadeFilter").val(),
            order_by: $("#orderBySelect").val(),
        };
    }
);

// Address lookup by CEP for clients
$(function () {
    $(".inputCep").on("input", function () {
        const cep = $(this).val();
        const tipoCliente = $(this).data("form");
        const clientType = tipoCliente !== "PJ" ? "" : "PJ";

        buscarEnderecoPorCep(cep, clientType)
            .then(function (response) {
                const data = response.data.result;
                const {
                    bairro,
                    complemento,
                    localidade: cidade,
                    logradouro: endereco,
                    uf: estado,
                } = data;
                const estadoValue = (estado || "").toString().trim();
                const cidadeValue = (cidade || "").toString().trim();
                const apiMunicipios = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoValue.toLowerCase()}/municipios?orderBy=nome`;

                $(`#inputState${clientType}`).val(estadoValue);

                // Load municipalities
                $.ajax({
                    url: apiMunicipios,
                    method: "GET",
                    success: function (municipios) {
                        $(`#inputCity${clientType}`).empty();
                        $(`#inputCity${clientType}`).append(
                            "<option>Escolha sua cidade</option>"
                        );

                        municipios.forEach(function (municipio) {
                            const option = `<option value="${municipio.nome}">${municipio.nome}</option>`;
                            $(`#inputCity${clientType}`).append(option);
                        });

                        const lowerCidade = cidadeValue.toLowerCase();
                        $(`#inputCity${clientType}`)
                            .find("option")
                            .each(function () {
                                const thisLower = $(this).val().toLowerCase();
                                if (thisLower === lowerCidade) {
                                    $(this).attr("selected", true);
                                }
                            });
                    },
                    error: function (xhr, status, error) {
                        // Fallback: adiciona opção padrão
                        $(`#inputCity${clientType}`).empty();
                        $(`#inputCity${clientType}`).append(
                            "<option>Erro ao carregar cidades</option>"
                        );
                    },
                });

                $(`#inputDistrict${clientType}`).val(bairro);
                $(`#inputAddress${clientType}`).val(endereco);
                $(`#inputAddressComplement`).val(complemento);
            })
            .catch(function (error) { });
    });

    // State change handler
    $(document).on("change", "#inputState", function () {
        const value = ($(this).val() || "").toString().trim();
        $(".inputCity").empty();
        $(".inputCity").append('<option value="">Escolha sua cidade</option>');
        if (!value) {
            return;
        }
        const apiMunicipios = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${value.toLowerCase()}/municipios?orderBy=nome`;

        $.ajax({
            url: apiMunicipios,
            method: "GET",
            success: function (data) {
                $(".inputCity").empty();
                $(".inputCity").append(
                    '<option value="">Escolha sua cidade</option>'
                );
                data.forEach(function (municipio) {
                    const option = `<option value="${municipio.nome}">${municipio.nome}</option>`;
                    $(".inputCity").append(option);
                });
            },
            error: function (xhr, status, error) {
                // Fallback: adiciona opção padrão
                $(".inputCity").empty();
                $(".inputCity").append(
                    '<option value="">Erro ao carregar cidades</option>'
                );
            },
        });
    });

    // Load cities on edit pages
    if (
        $("body").hasClass("client-edit") ||
        $("body").hasClass("settings-garage") ||
        $("body").hasClass("settings")
    ) {
        const $estadoEl = $("#inputState");
        const $cidadeEl = $("#cityHidden");
        const estado = ($estadoEl.val() || "").toString().trim();
        const cidade = ($cidadeEl.val() || "").toString().trim();

        if ($estadoEl.length && estado !== "") {
            const apiMunicipios = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado.toLowerCase()}/municipios?orderBy=nome`;

            $.ajax({
                url: apiMunicipios,
                method: "GET",
                success: function (data) {
                    $(".inputCity").empty();
                    $(".inputCity").append(
                        '<option value="">Escolha sua cidade</option>'
                    );

                    data.forEach(function (municipio) {
                        const selected =
                            municipio.nome === cidade ? "selected" : "";
                        const option = `<option value="${municipio.nome}" ${selected}>${municipio.nome}</option>`;
                        $(".inputCity").append(option);
                    });
                },
                error: function (xhr, status, error) {
                    // Fallback: adiciona opção padrão
                    $(".inputCity").empty();
                    $(".inputCity").append(
                        '<option value="">Erro ao carregar cidades</option>'
                    );
                },
            });
        }
    }
});

// CNPJ lookup functionality
$(function () {
    $(".inputCnpj").on("input", function () {
        const cnpj = $(this).val();

        buscarDadosCnpj(cnpj)
            .then(function (response) {
                const data = response.data.result;
                const {
                    bairro,
                    complemento,
                    municipio: cidade,
                    logradouro: endereco,
                    uf: estado,
                    numero,
                } = data;

                $("#inputCompanyNamePJ").val(data.nome || data.fantasia);
                $("#inputStatePJ").val(estado);
                $("#inputDistrictPJ").val(bairro);
                $("#inputAddressPJ").val(endereco);
                $("#InputNumberAddressPJ").val(numero);
                $("#inputAddressComplementPJ").val(complemento);
            })
            .catch(function (error) { });
    });
});

// Load clients for select2
$(function () {
    const $selectClient = $("#selectClient");
    if (!$selectClient.length) return;

    // Skip if on Service Order Create page (handled by form-manager.js)
    if ($(".formCreateServcieOrder").length > 0) return;

    $.ajax({
        url: "/clientes/getClients",
        type: "POST",
        dataType: "json",
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (data) {
            const baseList = Array.isArray(data.results)
                ? data.results
                : Array.isArray(data.clients)
                    ? data.clients
                    : [];
            const dataSelect = baseList

                .map((cliente) => {
                    if (cliente && typeof cliente.text === "string") {
                        return { id: cliente.id, text: cliente.text };
                    }
                    const textBase =
                        cliente?.tipo_cliente === "PF"
                            ? cliente?.nome
                            : cliente?.razao_social;
                    return { id: cliente?.id, text: textBase || "" };
                })
                .filter((item) => item && item.text !== "")
                .sort((a, b) => (a.text || "").localeCompare(b.text || ""));

            const selectedClientId = $selectClient.data("selected-client");

            // Preservar o valor atual se já existe (modo edição)
            const currentValue = $selectClient.val();
            const hasPreselectedValue = currentValue && currentValue !== "";

            $selectClient.select2({
                data: dataSelect,
                placeholder: "Selecione um cliente",
                language: "pt-BR",
                allowClear: true,
                minimumInputLength: 0,
            });

            // Priorizar valor atual do HTML, depois data attribute
            const valueToSet = hasPreselectedValue
                ? currentValue
                : selectedClientId;

            if (valueToSet) {
                $selectClient.val(valueToSet).trigger("change");
            } else {
                $selectClient.val(null).trigger("change");
            }

            $(document).trigger("clientesCarregados");
        },
    });

    // Initialize vehicle select
    // Check if we are not in the Service Order Create page (which handles its own Select2 logic)
    if ($(".formCreateServcieOrder").length === 0) {
        $("#selectVehicle").select2({
            placeholder: "Selecione um veículo",
            language: "pt-BR",
            allowClear: true,
            minimumInputLength: 0,
        });
    }

    // Handler para carregar veículos quando cliente é selecionado
    $("#selectClient").on("change", function () {
        // Se estiver na página de criação de OS, pular esta lógica pois o form-manager.js gerencia isso
        if ($(".formCreateServcieOrder").length > 0) {
            return;
        }

        const clientId = $(this).val();
        const vehicleSelect = $("#selectVehicle");
        const selectedVehicleId = vehicleSelect.data("selected-vehicle");
        const isEditMode = selectedVehicleId && vehicleSelect.data("client-id");

        // Preservar o valor atual do veículo se já existe (modo edição)
        const currentVehicleValue = vehicleSelect.val();
        const hasPreselectedVehicle =
            currentVehicleValue && currentVehicleValue !== "";

        if (clientId) {
            // Limpar e desabilitar select de veículos
            vehicleSelect
                .empty()
                .append('<option value="">Carregando veículos...</option>')
                .prop("disabled", true);

            // Carregar veículos do cliente
            $.ajax({
                url: `/OS/buscar-veiculos-cliente/${clientId}`,
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                },
                success: function (response) {
                    vehicleSelect
                        .empty()
                        .append(
                            '<option value="">Selecione um veículo</option>'
                        );

                    if (
                        response.success &&
                        response.vehicles &&
                        response.vehicles.length > 0
                    ) {
                        response.vehicles.forEach(function (vehicle) {
                            vehicleSelect.append(
                                `<option value="${vehicle.id}">${vehicle.text}</option>`
                            );
                        });

                        // Priorizar valor atual do HTML, depois data attribute
                        const vehicleValueToSet = hasPreselectedVehicle
                            ? currentVehicleValue
                            : selectedVehicleId;

                        if (response.vehicles.length === 1) {
                            // Se o cliente tem apenas um veículo e não há valor pré-selecionado,
                            // selecionar automaticamente esse único veículo
                            vehicleSelect
                                .val(response.vehicles[0].id)
                                .trigger("change");
                        } else if (vehicleValueToSet) {
                            vehicleSelect
                                .val(vehicleValueToSet)
                                .trigger("change");
                            // Limpar o data attribute para evitar re-seleção desnecessária
                            vehicleSelect.removeData("selected-vehicle");
                        }
                    } else {
                        vehicleSelect.append(
                            '<option value="">Nenhum veículo encontrado</option>'
                        );
                    }

                    vehicleSelect.prop("disabled", false);
                    $(document).trigger("veiculosCarregados");
                },
                error: function (xhr, status, error) {
                    vehicleSelect
                        .empty()
                        .append(
                            '<option value="">Erro ao carregar veículos</option>'
                        )
                        .prop("disabled", false);
                },
            });
        } else {
            // Se nenhum cliente selecionado, limpar veículos
            vehicleSelect
                .empty()
                .append(
                    '<option value="">Selecione um cliente primeiro</option>'
                )
                .prop("disabled", true);
        }
    });
});
